module.exports = {
  INIT: 'init',
  PLANNED: 'planned',
  PLANNEDNOSUPPLIER: 'planned-no-supplier',
  CANCELLED: 'cancelled',
  ENDED: 'ended',
};
